interface Props {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ title, description, action }: Props): JSX.Element {
  return (
    <div className="text-center py-16 px-4 border border-dashed border-slate-700 rounded-xl bg-slate-900/30">
      <h3 className="text-sm font-medium text-slate-200">{title}</h3>
      {description !== undefined && description !== '' && (
        <p className="mt-2 text-xs text-slate-500">{description}</p>
      )}
      {action !== undefined && <div className="mt-4">{action}</div>}
    </div>
  );
}
